import React, { useEffect, useState } from 'react';
import { CheckCircle, AlertCircle, Info, X } from 'lucide-react';

const CONFIGS = {
    success: {
        icon: <CheckCircle size={18} />,
        bg: 'linear-gradient(135deg,#10b981,#34d399)',
        border: 'rgba(16,185,129,0.35)',
        glow: '0 8px 32px rgba(16,185,129,0.3)',
    },
    error: {
        icon: <AlertCircle size={18} />,
        bg: 'linear-gradient(135deg,#ef4444,#f87171)',
        border: 'rgba(239,68,68,0.35)',
        glow: '0 8px 32px rgba(239,68,68,0.3)',
    },
    info: {
        icon: <Info size={18} />,
        bg: 'linear-gradient(135deg,#6366f1,#818cf8)',
        border: 'rgba(99,102,241,0.35)',
        glow: '0 8px 32px rgba(99,102,241,0.3)',
    },
};

const Toast = ({ message, type = 'success', onClose }) => {
    const [visible, setVisible] = useState(true);
    const cfg = CONFIGS[type] || CONFIGS.info;

    useEffect(() => {
        const out = setTimeout(() => setVisible(false), 3000);
        const close = setTimeout(onClose, 3350);
        return () => { clearTimeout(out); clearTimeout(close); };
    }, [onClose]);

    return (
        <div
            style={{
                position: 'fixed', bottom: 24, right: 24, zIndex: 9999,
                display: 'flex', alignItems: 'center', gap: 12,
                padding: '14px 18px 14px 16px',
                background: cfg.bg, borderRadius: 14,
                border: `1px solid ${cfg.border}`,
                boxShadow: cfg.glow,
                color: '#fff', fontSize: '0.875rem', fontWeight: 600,
                fontFamily: 'Inter,system-ui,sans-serif',
                minWidth: 260, maxWidth: 400,
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0) scale(1)' : 'translateY(8px) scale(0.97)',
                transition: 'opacity 0.35s ease, transform 0.35s ease',
            }}
        >
            <span style={{ flexShrink: 0, display: 'flex' }}>{cfg.icon}</span>
            <span style={{ flexGrow: 1, lineHeight: 1.4 }}>{message}</span>
            <button
                onClick={onClose}
                style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 7, width: 26, height: 26, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', flexShrink: 0, transition: 'background 0.15s' }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.35)'}
                onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
            >
                <X size={13} />
            </button>
        </div>
    );
};

export default Toast;
